import BaseModel from '../BaseModel';
import OfficeInterviewLog from './OfficeInterviewLog';
import OfficeInterviewImage from './OfficeInterviewImage';

export default class OfficeInterview extends BaseModel {
  static entity = 'officeInterviews';

  static primaryKey = 'id';

  static fields() {
    return {
      id: this.attr(null),
      candidateId: this.attr(null),
      status: this.string(null).nullable(),
      publication: this.attr(null),
      video: this.attr(null),
      canPublish: this.boolean(null).nullable(),
      logs: this.hasMany(OfficeInterviewLog, 'officeInterviewId'),
      images: this.hasMany(OfficeInterviewImage, 'interviewId'),
      interviewData: this.attr(null).nullable(),
      videoCallCandidateUrl: this.attr(null).nullable(),
      videoCallAdminUrl: this.attr(null).nullable(),
      createdAt: this.attr(null).nullable(),
      type: this.attr(null).nullable(),
      emptyVideo: this.boolean(null).nullable(),
    };
  }

  static apiConfig = {
    actions: {
      store(candidateId) {
        return this.post(`candidates/${candidateId}/office-interview`);
      },
      destroy(id) {
        return this.delete(`/office-interviews/${id}`);
      },
      startPublication(id) {
        return this.post(`office-interviews/${id}/publication`);
      },
      continuePublication(id) {
        return this.patch(`office-interviews/${id}/publication`);
      },
      stopPublication(id) {
        return this.delete(`office-interviews/${id}/publication`);
      },
      storeVideoCall(candidateId) {
        return this.post(`candidates/${candidateId}/video-call`);
      },
      storeUploadedVideo(candidateId, payload) {
        return this.post(`candidates/${candidateId}/uploaded_video_interview`, payload, {
          timeout: 3600000,
        });
      },
    },
  }
}
